import * as React from 'react';
import { StyledDescription, StyledDiv, StyledTitle, ButtonContainer, StyledDivWarning, StyledDivError, IconTextContainer, TextContainer, } from './styles/ToastsStyles';
import InfoCircleSvg from './icons/InfoCircleSvg';
var Toast = function (_a) {
    var variant = _a.variant, title = _a.title, description = _a.description, onContinue = _a.onContinue, onClose = _a.onClose, showButtons = _a.showButtons, _b = _a.continueButtonText, continueButtonText = _b === void 0 ? 'OK' : _b, _c = _a.closeButtonText, closeButtonText = _c === void 0 ? 'Close' : _c;
    if (variant === 'info') {
        return (React.createElement(StyledDiv, null,
            React.createElement(IconTextContainer, null,
                React.createElement(InfoCircleSvg, { color: "#456372" }),
                React.createElement(TextContainer, null,
                    React.createElement(StyledTitle, null, title),
                    React.createElement(StyledDescription, null, description))),
            showButtons && (React.createElement(ButtonContainer, null,
                React.createElement("button", { onClick: onContinue }, continueButtonText),
                React.createElement("button", { onClick: onClose }, closeButtonText)))));
    }
    if (variant === 'warning') {
        return (React.createElement(StyledDivWarning, null,
            React.createElement(IconTextContainer, null,
                React.createElement(InfoCircleSvg, { color: "#E6A800" }),
                React.createElement(TextContainer, null,
                    React.createElement(StyledTitle, null, title),
                    React.createElement(StyledDescription, null, description))),
            showButtons && (React.createElement(ButtonContainer, null,
                React.createElement("button", { onClick: onContinue }, continueButtonText),
                React.createElement("button", { onClick: onClose }, closeButtonText)))));
    }
    if (variant === 'error') {
        return (React.createElement(StyledDivError, null,
            React.createElement(IconTextContainer, null,
                React.createElement(InfoCircleSvg, { color: "#FF6A57" }),
                React.createElement(TextContainer, null,
                    React.createElement(StyledTitle, null, title),
                    React.createElement(StyledDescription, null, description))),
            showButtons && (React.createElement(ButtonContainer, null,
                React.createElement("button", { onClick: onContinue }, continueButtonText),
                React.createElement("button", { onClick: onClose }, closeButtonText)))));
    }
    return React.createElement(React.Fragment, null, "Please provide variant");
};
export default Toast;
//# sourceMappingURL=Toast.js.map